import api from "../../../utils/api";

//list ncr
export const getNCR = async () => {
    const res = await api.get("/ncr");
    return res.data;
}

//create ncr
export const createNCR = async (payload) => {
    const res = await api.post("/ncr", payload);
    return res.data;
}

//view ncr details
export const getNCRById = async (id) => {
    const res = await api.get(`/ncr/${id}`);
    return res.data;
}

//update ncr
export const updateNCR = async (id, payload) => {
    const res = await api.put(`/ncr/${id}`, payload);
    return res.data;
}

//delete ncr
export const deleteNCR = async (id) => {
    const res = await api.delete(`/ncr/${id}`);
    return res.data;
}

// get users for assignment
export const getUsers = async () => {
    const res = await api.get("/users");
    return res.data;
};

//assign ncr
export const assignNCR = async (id, payload) => {
    const res = await api.patch(`/ncr/${id}/assign`, payload);
    return res.data;
}

//mark in progress ncr
export const markInProgress = async (id) => {
    const res = await api.patch(`/ncr/${id}/in-progress`);
    return res.data;
}

//mark corrected ncr
export const markCorrected = async (id) => {
    const res = await api.patch(`/ncr/${id}/corrected`);
    return res.data;
}

//close ncr
export const closeNCR = async (id) => {
    const res = await api.patch(`/ncr/${id}/close`);
    return res.data;
}

//upload ncr attachment
export const uploadNCRAttachment = async (id, file) => {
    const formData = new FormData();
    formData.append("file", file);

    const res = await api.post(`/api/ncr/${id}/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
    });

    return res.data;
};

//get ncr by project id
export const getNCRsByProjectId = async (projectId) => {
    const res = await api.get(`/ncr/project/${projectId}`);
    return res.data;
}